import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SharedLibraryService } from "../services/shared.config";
import { Observable } from "rxjs";
import { SurveySubmission } from "../shared-models/survey-submission.model";

@Injectable({
  providedIn: 'root'
})
export class CheckInsSummaryPopUpService {
  private token = localStorage.getItem('token');
  private headers = new HttpHeaders().set(
    'Authorization',
    `Bearer ${this.token}`
  );

  constructor(private http: HttpClient,
              private sharedLibraryService: SharedLibraryService) { }

  getSurveySubmissionsByOwnerAndAnimal(ownerId: string, animalId: string, app: number): Observable<SurveySubmission[]> {
    let appName = 'Owner';

    if (app === 2) {
      appName = 'Staff';
    } else if (app === 3) {
      appName = 'Shelter';
    }
    const apiUrl = this.sharedLibraryService.getSharedLibraryConfig().apiUrl;
    const url = `${apiUrl}${appName}/SurveySubmissions/Owner/${ownerId}/Animal/${animalId}`;
    return this.http.get<SurveySubmission[]>(url, { headers: this.headers });
  }
}
